import DefaultLayout from "./DefaultLayout/DefaultLayout";

export { DefaultLayout };
